import Vue from "vue";
import { Component } from "vue-property-decorator";
import { stringMaxLength } from "../../../assets/validation/common";
import { SupervisorPlaceSpecificGoodItemRestModel } from "../../../models/rest/supervisor/supervisorPlaceSpecificGoodRestModel";

@Component
export default class SpecificGoodItemDialog extends Vue {
    validation = {
        material: [
            stringMaxLength(this.$i18n, this.$t("supervisor.supervisorPlaceSpecificGoodItemMaterial"), 100),
            (value: string) => !!value || this.$t("common.validationErrorRequired")
        ],
        materialDescription: [
            stringMaxLength(this.$i18n, this.$t("supervisor.supervisorPlaceSpecificGoodItemMaterialDescription"), 255),
            (value: string) => !!value || this.$t("common.validationErrorRequired")
        ],
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    get showDialog(): boolean {
        return this.$store.direct.state.supervisor.showSpecificGoodItemDialog;
    }

    get title(): string {
        return this.$store.direct.state.supervisor.specificGoodItemDialogTitle;
    }

    get specificGoodItem(): SupervisorPlaceSpecificGoodItemRestModel {
        return this.$store.direct.state.supervisor.specificGoodItem;
    }

    cancelClick() {
        this.$store.direct.dispatch.supervisor.isNotConfirmedSpecificGoodItemDialog();
    }

    async saveClick() {
        const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

        if (valid) {
            await this.$store.direct.dispatch.supervisor.saveSpecificGoodItem();
            await this.$store.direct.dispatch.supervisor.isConfirmedSpecificGoodItemDialog();
        }
    }
}